import React from 'react'
import '../Assets/Css/ecommerce.css';
import { Helmet } from 'react-helmet';

export default function Ecommerce() {
  return (
    <div style={{ minHeight: '100vh' }}>
     
      <Helmet>
  <title>E-Commerce Services Coming Soon | Trident E-Commerce Services</title>
  <meta name="description" content="Empowering your digital transformation — our cutting-edge e-commerce Services are launching soon. Stay tuned for innovation, performance, and scalability." />
  
  {/* Open Graph */}
  <meta property="og:title" content="Coming Soon | Trident E-Commerce" />
  <meta property="og:description" content="Empowering your digital transformation — our cutting-edge IT Services are launching soon." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://tridentsoftwareservice.com/ecommerce" />
  <meta property="og:image" content="https://tridentsoftwareservice.com/images/ecommerce-coming-soon.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Coming Soon | Trident E-Commerce Services" />
  <meta name="twitter:description" content="Trident is preparing to launch next-gen e-commerce tech. Stay tuned for scalable, secure, and future-ready Services." />
  <meta name="twitter:image" content="https://tridentsoftwareservice.com/images/ecommerce-coming-soon-twitter.jpg" />
</Helmet>

       <div className=" bannerecommer-section d-flex align-items-center justify-content-center">
          <div className="bannerecommer-overlay text-center" data-aos="zoom-in">
            <h2 className="banner1-title">Coming Soon....</h2>
            <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
               Empowering your digital transformation — our cutting-edge IT Services are launching soon. Stay tuned!
            </p>

          </div>
        </div>
    </div>
  )
}
